<table class="activation-table">
  <thead class="table-header">
    <tr>
      <th class="product-section header" id="package-header">
        <div class="product-header-container">
          <div class="icon-container">
            <mat-icon *ngIf="sortIndicator" (click)="sortItems()">
              {{ sortIndicator }}
            </mat-icon>
          </div>
          <div class="header-text-container">
            {{ 'ACTIVATION.SELECTION_PAGE.PACKAGE_ACTIVATION_TABLE.PACKAGE_NAME' | translate }}
          </div>
        </div>
      </th>
      <th class="quantity-section header">
        <div class="header-text-container">
          <span>{{ 'COMMON.PRICING.QUANTITY' | translate }}</span>
        </div>
      </th>
      <th class="pricing-section header last-column">
        <div class="header-text-container">
          <span *ngIf="!hidePricing">
            {{ 'COMMON.PRICING.WHOLESALE_PRICING' | translate }}
          </span>
        </div>
      </th>
    </tr>
  </thead>
  <tbody>
    <ng-container *ngFor="let pkg of activatablePackages">
      <ng-container *ngIf="!pkg.restricted || showRestricted">
        <tr
          app-activatable-package-row
          [activatablePackage]="pkg"
          (click)="onPackageSelectionChanged(pkg)"
          class="pkg-row"
        ></tr>
        <tr
          app-activatable-package-items-row
          *ngFor="let child of pkg.activatableItemCount"
          [activatableItemCount]="child"
          [hidePricing]="hidePricing"
          (click)="onPackageSelectionChanged(pkg)"
        ></tr>
        <tr class="app-border">
          <td></td>
          <td></td>
          <td></td>
        </tr>
      </ng-container>
    </ng-container>
  </tbody>
</table>
